import { palette } from 'src/styles/colors';
import { layout } from 'src/styles/layout';
import styled from 'styled-components';

export const EmailPopupMainWrapper = styled.div`
  position: fixed;
  max-width: 100% !important;
  max-height: 100%;
  width: 100vw;
  height: 100vh;
  opacity: 0;
  visibility: hidden;
  z-index: 199;
  transition: all 0.5s ease-in-out;

  &.isVisible {
    opacity: 100%;
    visibility: visible;
  }
`;

export const EmailPopupMainBackgroundOverlay = styled.div`
  position: absolute;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100vw;
  height: 100vh;
`;

export const EmailPopupMainContainer = styled.div`
  width: 100%;
  max-width: 880px;
  margin: 0 auto;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  overflow: hidden;
  border-radius: 16px;
  background-color: ${palette.white};
  display: grid;
  grid-template-columns: 402px 1fr;
  grid-template-areas: 'email-popup-image email-popup-text';

  @media all and (max-width: ${layout.md}) {
    grid-template-columns: 1fr;
    grid-template-areas: 'email-popup-text' 'email-popup-image';
    max-width: 450px;
    max-height: 80vh;
    overflow-y: scroll;
  }

  @media all and (max-width: ${layout.xs}) {
    max-width: 365px;
  }

  @media all and (max-width: 400px) {
    max-width: 345px;
  }
`;

export const EmailPopupMainImage = styled.div`
  grid-area: email-popup-image;
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  & > .gatsby-image-wrapper {
    max-width: 500px;
    width: 100%;
    height: 100%;
  }

  @media all and (max-width: ${layout.md}) {
    & > .gatsby-image-wrapper {
      max-width: initial;
    }
  }
`;

export const EmailPopupMainClose = styled.div`
  position: absolute;
  display: grid;
  align-content: flex-start;
  justify-content: end;
  margin-bottom: 1rem;
  top: 30px;
  right: 30px;
  z-index: 10;

  & > svg {
    width: 17px;
    height: 17px;
    cursor: pointer;
  }
`;

export const EmailPopupMainLayout = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 7rem 1rem;
  position: relative;
  max-width: 354px;
  justify-self: center;
  grid-area: email-popup-text;
  min-height: 350px;

  @media all and (max-width: ${layout.md}) {
    padding: 4rem 1.5rem 1.5rem;
    max-width: 420px;
    min-height: auto;
  }
`;

export const EmailPopupMainText = styled.div`
  & > h1 {
    margin-bottom: 1.125rem;
  }

  & > p {
    margin-bottom: 1rem;
  }

  &.hideMainText {
    display: none;
  }

  @media all and (max-width: ${layout.md}) {
    & > p,
    & > h1 {
      text-align: left !important;
    }
  }
`;

export const EmailPopupMainForm = styled.div`
  max-width: 350px;
  margin: 0 auto;
  margin-top: 1.5rem;

  & > button {
    margin-top: 1.5rem;
    width: 100%;
    margin-bottom: 1rem;
  }

  @media all and (max-width: ${layout.md}) {
    max-width: 420px;
  }
`;

export const EmailPopupMainThankYou = styled.div`
  & > p {
    margin-bottom: 1rem;
  }

  & > button {
    width: 100%;
    padding: 11px 80px 13px;
    margin: 1.5rem auto 0;
    display: block;
  }

  & > h1 {
    padding-bottom: 1rem;
  }

  @media all and (max-width: ${layout.md}) {
    & > p,
    & > h1 {
      text-align: left !important;
    }
  }

  @media all and (max-width: ${layout.xs}) {
    & > button {
      padding: 11px 0;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
    }
  }
`;

export const EmailPopupHubspotForm = styled.div`
  position: relative;
  display: grid;
  min-height: 85px;

  .hs-form-required {
    display: none;
  }

  > form {
    fieldset {
      display: grid;
      row-gap: 0.5rem;
      max-width: unset;

      div.legal-consent-container {
        display: none;
      }

      div.hs-form-field {
        width: 100% !important;
        float: none !important;
      }

      legend.hs-field-desc {
        display: none !important;
      }

      div.input {
        width: 100%;
        border-bottom: 1px solid ${palette.greyText};
        padding-bottom: 5px;
        box-sizing: border-box;

        input {
          text-align: left;
          font-size: 1rem;
          width: 100%;
          height: 100%;
          border: 0;
          box-sizing: border-box;
          color: ${palette.greyText};
          background: transparent;
          min-height: 33px;

          &:focus {
            outline: none;
          }

          &::placeholder {
            opacity: 0.5;
            font-weight: 700;
          }
        }
      }
    }

    .hs-error-msgs {
      color: ${palette.errorRed};
      margin: 0.25rem;
      font-size: 0.75rem;
      padding-left: 0rem;
      list-style: none;
    }

    input[type='submit'] {
      display: none;
    }
  }
`;
